import TableLibrary from './TableLibrary'

export default TableLibrary



// WEBPACK FOOTER //
// ./src/views/Channels/components/TableLibrary/index.js